// src/guards/withSubscriptionGuard.jsx
import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import api from '../service/caller';

const withSubscriptionGuard = (WrappedComponent, requiredFeature = null) => {
  return (props) => {
    const [user, setUser] = useState(null);
    const [subscription, setSubscription] = useState(null);
    const [loading, setLoading] = useState(true);
    const [unauthorized, setUnauthorized] = useState(false);
    const [expired, setExpired] = useState(false);

    useEffect(() => {
      const fetchData = async () => {
        try {
          const userRes = await api.get('api/usersprofile');
          const userData = userRes.data;
          setUser(userData);

          const subscriptionRes = await api.get(
            `api/adminsubscriptions/${userData.main_hospital_id}`
          );
          const subscriptionData = subscriptionRes.data;
          setSubscription(subscriptionData.subscription);

          // Détermination de la durée
          const now = new Date();
          const createdAt = new Date(subscriptionData.hospital?.subscriptAt);
          let expiry = new Date(createdAt);

          if (subscriptionData.subscription?.planDuration) {
            // Format spécifique à l'hôpital
            expiry.setMonth(expiry.getMonth() + subscriptionData.subscription?.planDuration);
          } else if (subscriptionData.subscription?.duration) {
            // Format global du plan
            expiry.setMonth(expiry.getMonth() + subscriptionData.subscription.duration);
          } else {
            console.warn('Durée de la souscription inconnue.');
            setUnauthorized(true);
            setLoading(false);
            return;
          }

          if (now > expiry) {
            setExpired(true);
            return;
          }

          // Vérifie l'accès à la fonctionnalité requise
          if (requiredFeature) {
            const features = subscriptionData.subscription.features || [];

            const hasFeature = features.some((f) => {
              const feature = f.feature || f.featureId;
              return feature?.name === requiredFeature;
            });

            if (!hasFeature) {
              setUnauthorized(true);
              return;
            }
          }
        } catch (error) {
          console.error('Erreur guard:', error);
          setUnauthorized(true); // redirige si erreur
        } finally {
          setLoading(false);
        }
      };

      fetchData();
    }, []);

    if (loading) return <div>Chargement...</div>;
    if (!user) return <Navigate to="/Clientlogin" />;
    if (expired) return <Navigate to="/subscription/expired" />;
    if (unauthorized) return <Navigate to="/unauthorized" />;

    return <WrappedComponent {...props} />;
  };
};

export default withSubscriptionGuard;
